export default "__VITE_ASSET__BUrcjPx9__"